export default {
    SET_AVATAR_DATA: "SET_AVATAR_DATA",
    REMOVE_AVATAR_DATA: "REMOVE_AVATAR_DATA"
};
